import { render, staticRenderFns } from "./NodeAffinity.vue?vue&type=template&id=0cbff3a4&"
import script from "./NodeAffinity.vue?vue&type=script&lang=js&"
export * from "./NodeAffinity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports